import FontText from "../../../../../../FontText/FontText";
import React from "react";
import { BaseTheme } from "../../../../../../Themes/BaseTheme";
import { FontSizeEnum, FontTypeEnum } from "../../../../../../FontText/FontTextEnums";
import { ThemeColorEnum } from "../../../../../../Themes/ThemeEnums";

interface ColorfulBrandTextProps {
  fontSize: FontSizeEnum;
}

const ColorfulBrandText: React.FC<ColorfulBrandTextProps> = ({ fontSize }) => {
  return (
    <>
      <FontText
        text={BaseTheme.typography.special_characters.space}
        $fontType={FontTypeEnum.TITLE}
        $fontSize={fontSize}
      />
      <FontText
        text={"P"}
        $color={ThemeColorEnum.CUSTOM_BLUE}
        $fontType={FontTypeEnum.TITLE}
        $fontSize={fontSize}
      />
      <FontText
        text={"i"}
        $color={ThemeColorEnum.CUSTOM_RED}
        $fontType={FontTypeEnum.TITLE}
        $fontSize={fontSize}
      />
      <FontText
        text={"č"}
        $color={ThemeColorEnum.CUSTOM_YELLOW}
        $fontType={FontTypeEnum.TITLE}
        $fontSize={fontSize}
      />
      <FontText
        text={"o"}
        $color={ThemeColorEnum.CUSTOM_BLUE}
        $fontType={FontTypeEnum.TITLE}
        $fontSize={fontSize}
      />
    </>
  );
};

export default ColorfulBrandText;
